export default Object.freeze({
    TwelveHourFormat: 0,
    TwentyFourHourFormat: 1,
});
